export default class UserResponse{
	public aptO1: string = "";
	public celular: string = "";
	public ciudaD1: string = "";
	public ciudad: string = "";
	public codciudaD1: string = "";
	public codecelular: string = "";
	public codefax: string = "";
	public codeotrotelefono: string = "";
	public codetelcasa: string = "";
	public codeteltrabajo: string = "";
	public codpersona: string = "";
	public codsectoR1: string = "";
	public domiciliO1: string = "";
	public edificiO1: string = "";
	public emailservidor: string = "";
	public emailusuario: string = "";
	public fax: string = "";
	public idnss: string = "";
	public numerO1: string = "";
	public otrotelefono: string = "";
	public primerapellido: string = "";
	public primernombre: string = "";
	public razonsocial: string = "";
	public sectoR1: string = "";
	public sector: string = "";
	public segundoapellido: string = "";
	public segundonombre: string = "";
	public telcasa: string = "";
	public teltrabajo: string = "";
}